<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <!-- <el-button type="primary" size="small" @click="add">同步群 </el-button> -->
        <span class="form-red">点击同步机器人数据可以更新群列表</span>
      </div>
      <div class="text-right">
        <el-input
          clearable
          v-model.trim="searchCondition.nickname"
          placeholder="请输入群名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <!-- <el-cascader
          v-model="searchCondition.categoryId"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="prop"
          clearable
          placeholder="请选择类目"
        ></el-cascader> -->
        <el-select
          :disabled="allMerchant.length === 0"
          style="width: 300px"
          size="small"
          clearable
          placeholder="请选择商户"
          v-model="searchCondition.queryStoreCode"
          class="mr10"
          filterable
          remote
          :remote-method="remoteMethod"
          @change="storeChange"
        >
          <el-option
            v-for="item in storeBasicList"
            :key="item.storeCode"
            :label="item.storeName"
            :value="item.storeCode"
          ></el-option>
        </el-select>
        <!-- <el-select
          size="small"
          clearable
          v-model="searchCondition.queryStoreCode"
          class="mr10"
          placeholder="请选择关联商户"
          filterable
          @change="storeChange"
        >
          <el-option
            v-for="(item, i) in storeList"
            :key="i"
            :label="item.storeName"
            :value="item.storeCode"
          ></el-option>
        </el-select> -->
        <el-select
          size="small"
          clearable
          v-model="searchCondition.shopId"
          class="mr10"
          placeholder="请选择关联门店"
          filterable
        >
          <el-option
            v-for="(item, i) in shopList"
            :key="i"
            :label="item.shopName"
            :value="item.shopId"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          clearable
          v-model="searchCondition.brandId"
          class="mr10"
          placeholder="请选择关联品牌"
          filterable
        >
          <el-option
            :label="v.brandName"
            :value="v.hemiaoBrandId"
            v-for="(v, i) in allBrandList"
            :key="i"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <div class="flex flex-end item-center">
        <el-button type="success" size="small" @click="outputExcel"
          >导出模板</el-button
        >
        <div
          class="pointer flex-center open-file el-button--primary el-button el-button--small mr10"
        >
          导入
          <input
            type="file"
            @change="importf"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="群名称"
          prop="nickname"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wxid"
          label="群ID"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="robotNickName"
          label="管理机器人"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="timeDay"
          label="群人数"
        >
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="群状态"
        >
          <template slot-scope="scope">
            <div
              :class="scope.row.enabledState === 'yes' ? 'success' : 'danger'"
            >
              {{ scope.row.enabledState === "yes" ? "正常" : "失联" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopNum"
          label="关联门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandNum"
          label="关联品牌"
        ></el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="300"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button type="text" size="small" @click="remove(scope.row)">
                删除
              </el-button>
              <el-button type="text" size="small" @click="edit(scope.row)">
                编辑
              </el-button>
              <el-button type="text" size="small" @click="msglog">
                消息日志
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="editShopBrand(scope.row)"
              >
                关联门店和品牌
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog width="1000px" :title="title" :visible.sync="dialogVisible">
      <div v-if="type === 'msglog'">
        <div class="mb10" style="color: #000; fontsize: 16px">
          <span class="mr20">九江爱因宝1群</span>
          群ID:456123981655616
        </div>
        <div style="height: 600px">
          <el-scrollbar style="height: 100%" class="page-component__scroll">
            <el-timeline>
              <el-timeline-item timestamp="2018/4/12" placement="top">
                <el-card>
                  <p>昵称 2018/4/12 20:46</p>
                  <h4>XXXXXXXXXXXXXXXXXXX</h4>
                </el-card>
              </el-timeline-item>
              <el-timeline-item timestamp="2018/4/12" placement="top">
                <el-card class="text-right">
                  <p>昵称 2018/4/12 20:46</p>
                  <h4>XXXXXXXXXXXXXXXXXXX</h4>
                </el-card>
              </el-timeline-item>
              <el-timeline-item timestamp="2018/4/12" placement="top">
                <el-card>
                  <p>昵称 2018/4/12 20:46</p>
                  <h4>XXXXXXXXXXXXXXXXXXX</h4>
                </el-card>
              </el-timeline-item>
              <el-timeline-item timestamp="2018/4/12" placement="top">
                <el-card class="text-right">
                  <p>昵称 2018/4/12 20:46</p>
                  <h4>XXXXXXXXXXXXXXXXXXX</h4>
                </el-card>
              </el-timeline-item>
              <el-timeline-item timestamp="2018/4/12" placement="top">
                <el-card class="text-right">
                  <p>昵称 2018/4/12 20:46</p>
                  <h4>XXXXXXXXXXXXXXXXXXX</h4>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </el-scrollbar>
        </div>
      </div>
      <div v-if="type === 'edit'">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="150px"
        >
          <el-form-item label="群名称：">{{ row.nickname }} </el-form-item>
          <el-form-item label="群ID：">{{ row.wxid }} </el-form-item>
          <el-form-item label="管理机器人名称：">
            {{ row.robotNickName }}</el-form-item
          >
          <el-form-item label="关联商户/门店：" prop="shopIds">
            <el-select
              :disabled="allMerchant.length === 0"
              style="width: 300px"
              size="small"
              clearable
              placeholder="请选择关联商户"
              v-model="ruleForm.storeCodeList"
              class="mr10"
              filterable
              multiple
              remote
              :remote-method="remoteMethodEdit"
              @change="storeDetailsChange"
            >
              <el-option
                v-for="item in storeEditList"
                :key="item.storeCode"
                :label="item.storeName"
                :value="item.storeCode"
              ></el-option>
            </el-select>
            <!-- <el-select
              size="small"
              clearable
              filterable
              multiple
              v-model="ruleForm.storeCodeList"
              class="mr10"
              placeholder="请选择关联商户"
              @change="storeDetailsChange"
            >
              <el-option
                v-for="(item, i) in storeList"
                :key="i"
                :label="item.storeName"
                :value="item.storeCode"
              ></el-option>
            </el-select> -->
            <el-select
              size="small"
              clearable
              multiple
              v-model="ruleForm.shopIds"
              class="mr10"
              placeholder="请选择关联门店"
              @change="changeSelect"
              @remove-tag="removeTag"
              filterable
            >
              <el-option
                label="全选"
                value="all"
                @click.native="selectAll"
              ></el-option>
              <el-option
                v-for="(item, i) in shopDetailsList"
                :key="i"
                :label="item.shopName"
                :value="item.shopId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联品牌：" prop="brandIds">
            <el-select
              size="small"
              clearable
              v-model="ruleForm.brandIds"
              class="mr10"
              placeholder="请选择关联品牌"
              filterable
              multiple
            >
              <el-option
                :label="v.brandName"
                :value="v.hemiaoBrandId"
                v-for="(v, i) in allBrandList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button size="small" type="primary" @click="editGroup"
            >确 认</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >取消</el-button
          >
        </span>
      </div>
    </el-dialog>
    <el-dialog
      append-to-body
      :visible.sync="importErrDialog"
      @close="importErrDialog = false"
      width="500px"
      title="提示"
    >
      <div>
        <div class="mb20 err-valid-goods-tips">以下微信群导入失败</div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="msg"
            label="失败原因"
          ></el-table-column>
        </el-table>
        <div class="flex flex-center item-center mt20">
          <el-button size="small" type="primary" @click="importErr"
            >知道了</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      append-to-body
      :visible.sync="dialogVisibleShop"
      @close="dialogVisibleShop = false"
      width="1000px"
      title="关联门店和品牌"
    >
      <div>
        <el-radio-group @change="changeTab" v-model="tab" size="small">
          <el-radio-button
            v-for="(v, i) in tabList"
            :key="i"
            :label="v.value"
            >{{ v.label }}</el-radio-button
          >
        </el-radio-group>
        <div v-if="tab === 'shop'">
          <div class="mt20 flex flex-between">
            <el-button type="primary" size="small" @click="addShop"
              >新增门店
            </el-button>
            <el-button type="primary" size="small" @click="batchDeleteShop"
              >批量删除门店
            </el-button>
          </div>
          <div class="mt20">
            <el-table
              :data="wxShopRelList"
              style="width: 100%"
              stripe
              size="small"
              border
              ref="wxShoptable"
              @selection-change="handleSelectionChangeWxShop"
              v-if="resetForm"
            >
              <el-table-column
                type="selection"
                header-align="center"
                align="center"
                width="50"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                :index="
                  (index) =>
                    index +
                    (currentPageWxShopRelList - 1) * pageSizeWxShopRelList +
                    1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="商户"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="shopName"
                label="门店"
              ></el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
                width="300"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button
                      type="text"
                      size="small"
                      @click="removeShop(scope.row)"
                    >
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="mt20 flex flex-between">
            <el-button type="primary" size="small" @click="addBrand"
              >新增品牌
            </el-button>
            <el-button type="primary" size="small" @click="batchDeleteBrand"
              >批量删除品牌
            </el-button>
          </div>
          <div class="mt20">
            <el-table
              :data="wxBrandRelList"
              style="width: 100%"
              stripe
              size="small"
              border
              ref="wxBrandtable"
              @selection-change="handleSelectionChangeWxBrand"
              v-if="resetForm"
            >
              <el-table-column
                type="selection"
                header-align="center"
                align="center"
                width="50"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                :index="
                  (index) =>
                    index +
                    (currentPageWxBrandRelList - 1) * pageSizeWxBrandRelList +
                    1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="品牌"
              ></el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
                width="300"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button
                      type="text"
                      size="small"
                      @click="removeBrand(scope.row)"
                    >
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="800px"
      :visible.sync="dialogVisibleAddBrand"
    >
      <div>
        <div class="flex flex-end">
          <el-input
            clearable
            v-model.trim="brandName"
            placeholder="请输入品牌名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="brandSearch"
            >查询</el-button
          >
        </div>
        <div>
          <div class="tables mt20">
            <el-table
              stripe
              ref="brandTable"
              :data="brandList"
              style="width: 100%"
              id="table"
              @row-click="tableSelectBrand"
              size="small"
              border
              max-height="500"
              @selection-change="handleSelectionChangeBrand"
            >
              <el-table-column
                type="selection"
                header-align="center"
                align="center"
                width="50"
              >
              </el-table-column>
              <el-table-column
                type="index"
                label="序号"
                align="center"
                :index="
                  (index) => index + (brandCurrentPage - 1) * brandPageSize + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="品牌"
              ></el-table-column>
            </el-table>
          </div>
          <div class="hm-pagination mt20">
            <el-pagination
              background
              small
              :pager-count="5"
              :total="brandTotal"
              @current-change="brandPaging"
              @size-change="brandHandleSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="brandCurrentPage"
            ></el-pagination>
          </div>
          <div class="btn-wrapper flex flex-center mt20">
            <el-button size="small" type="primary" @click="brandConfirm()"
              >确 定</el-button
            >
            <el-button size="small" @click="dialogVisibleAddBrand = false">取 消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="1600px"
      :before-close="qx"
      :visible.sync="dialogVisibleAddShop"
    >
      <div class="flex">
        <div class="mr10" style="width: 600px">
          <div class="table-panel flex flex-between">
            <div style="width: 100%">
              <el-button
                type="primary"
                size="small"
                @click="storeSearch"
                >查询</el-button
              >
              <el-input
                clearable
                v-model.trim="storeName"
                placeholder="请输入商户"
                size="small"
                class="ipt ml10"
              >
              </el-input>
            </div>
          </div>
          <div class="table-panel">
            <div class="tables">
              <el-table
                stripe
                ref="roleTable"
                :data="storeBasucList.records"
                style="width: 100%"
                id="table"
                @row-click="tableSelect"
                size="small"
                border
                max-height="500"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  header-align="center"
                  align="center"
                  width="50"
                >
                </el-table-column>
                <!-- <el-table-column width="36">
                  <template slot-scope="scope">
                    <el-radio
                      :label="scope.row.storeCode"
                      v-model="storeCode"
                      @change.native="getTemplateRow(scope.$index, scope.row)"
                      >&nbsp;</el-radio
                    >
                  </template>
                </el-table-column> -->
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  :index="
                    (index) =>
                      index + (storeCurrentPage - 1) * storePageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="storeName"
                  label="商户"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="shopCount"
                  width="90"
                  label="门店数"
                ></el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                background
                small
                :pager-count="5"
                :total="storeBasucList.total"
                @current-change="storePaging"
                @size-change="storeHandleSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="storeCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div class="mar10 seach_checked">
          <el-button class="btn" type="primary" size="small" @click="searchShop"
            >查询勾选商户门店</el-button
          >
        </div>
        <div class="mr10 w60" style="width: 800px">
          <div class="table-panel flex flex-between">
            <div class="fr">
              <el-input
                clearable
                v-model.trim="shopName"
                placeholder="请输入门店名称"
                size="small"
                class="ipt mr10"
              ></el-input>
              <el-button type="primary" size="small" @click="shopSearch"
                >查询</el-button
              >
              <!-- <el-button type="primary" size="small" @click="outputExcel"
              >导出模板</el-button
              >
              <el-button type="primary" size="small" class="open-file"
              >
                导入门店
                <input
                    type="file"
                    @change="importf"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                </el-button
              > -->
            </div>
          </div>
          <div class="table-panel">
            <div class="table">
              <el-table
                stripe
                ref="rightData"
                :data="notRelShopList.records"
                style="width: 100%"
                id="table"
                size="small"
                @row-click="rightTableSelect"
                @selection-change="getShopChecked"
                border
                max-height="500"
              >
                <el-table-column type="selection"></el-table-column>
                <el-table-column
                  type="index"
                  label="序号"
                  :index="
                    (index) => index + (shopCurrentPage - 1) * shopPageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="storeName"
                  label="商户"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  width="150"
                  prop="shopName"
                  label="门店名称"
                >
                  <template slot-scope="scope">
                    <div class="flex item-center">
                      <span>{{ scope.row.shopName }}</span>
                      <span
                        v-if="scope.row.shopMonthlyStatementFlag"
                        class="monthlyStatement-wrapper"
                        >月结</span
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="所在省/市/区"
                  prop="citys"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.provinceName }}{{ scope.row.cityName
                      }}{{ scope.row.districtName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="详细地址"
                  prop="shopAddress"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                small
                background
                :total="notRelShopList.total"
                @current-change="shopPaging"
                @size-change="shopHandleSizeChange"
                layout="total,sizes, prev, pager, next, jumper"
                :current-page="shopCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm()"
          >确 定</el-button
        >
        <el-button size="small" @click="qx">取 消</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { unique, arrayUnique2, getSubtract2 } from "@/utils/utils";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    return {
      type: "",
      title: "",
      list: [],
      dialogVisible: false,
      importErrDialog: false,
      errInputResult: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        queryStoreCode: "",
        shopId: "",
      },
      ruleForm: {
        storeCodeList: [],
        shopIds: [],
        brandIds: [],
      },
      rules: {
        // robotWxid: {
        //   required: true,
        //   message: "请输入机器人微信号",
        //   trigger: "blur"
        // },
        // groupInfoModelList: {
        //   required: true,
        //   message: "请输入匹配机器人微信号",
        //   trigger: "blur"
        // }
      },
      storeList: [],
      shopList: [],
      allBrandList: [],
      shopDetailsList: [],
      row: {},
      storeBasicList: [],
      allMerchant: [],
      storeEditList: [],
      dialogVisibleShop: false,
      tab: "shop",
      tabList: [
        {
          label: "门店",
          value: "shop",
        },
        {
          label: "品牌",
          value: "brand",
        },
      ],
      wxShopRelList: [],
      currentPageWxShopRelList: 1,
      pageSizeWxShopRelList: 10,
      currentPageWxBrandRelList: 1,
      pageSizeWxBrandRelList: 10,
      dialogVisibleAddShop: false,
      storeName: "",
      storeCurrentPage: 1,
      storePageSize: 10,
      shopCurrentPage: 1,
      shopPageSize: 10,
      checkedShopRow: [],
      departIds: "",
      shopName: "",
      storeCodeList: [],
      wxBrandRelList: [],
      wxShopListSelect: [],
      dialogVisibleAddBrand: false,
      brandName: "",
      brandList: [],
      brandListSelect:[],
      wxbrandListSelect: [],
      brandCurrentPage: 1,
      brandPageSize: 10,
      brandTotal: 0,
      resetForm: false,
      batchProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationList", {
                pageNo: 1,
                pageSize: 999,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                res.result.records.forEach((v) => {
                  v.leaf = Boolean(!v.isParent);
                  v.all = {
                    label: v.departName,
                    value: v.id,
                  };
                  v.value = v.all;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryListOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    v.all = {
                      label: v.departName,
                      value: v.id,
                    };
                    v.value = v.all;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
    };
  },
  computed: mapGetters(["storeBasucList", "notRelShopList"]),
  watch: {},
  created() {},
  mounted() {
    this.queryStoreList();
    this.queryBrandList();
    this.queryList();
  },
  methods: {
    removeTag(val) {
      if (val === "all") {
        this.ruleForm.shopIds = [];
      }
    },
    changeSelect(val) {
      if (!val.includes("all") && val.length === this.shopDetailsList.length) {
        this.ruleForm.shopIds.unshift("all");
      } else if (
        val.includes("all") &&
        val.length - 1 < this.shopDetailsList.length
      ) {
        this.ruleForm.shopIds = this.ruleForm.shopIds.filter((item) => {
          return item !== "all";
        });
      }
    },
    selectAll() {
      if (this.ruleForm.shopIds.length < this.shopDetailsList.length) {
        this.ruleForm.shopIds = [];
        this.shopDetailsList.map((item) => {
          this.ruleForm.shopIds.push(item.shopId);
        });
        this.ruleForm.shopIds.unshift("all");
      } else {
        this.ruleForm.shopIds = [];
      }
    },
    async editGroup() {
      let params = this.ruleForm;
      params.wxid = this.row.wxid;
      const { code } = await this.$store.dispatch("editGroupInfoNew", params);
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.dialogVisible = false;
        this.queryList();
      }
    },
    storeChange(val) {
      return;
      this.searchCondition.shopId = "";
      this.queryShopList(val);
    },
    storeChangeShop(val) {
      this.shopCondition.shopId = "";
      this.queryShopList(val);
    },
    storeDetailsChange(val) {
      this.ruleForm.shopIds = [];
      console.log("val", val);
      if (val && val.length > 0) {
        this.queryShopDetailsList(val);
      }
    },
    async queryShopList(val) {
      let params = {
        pageSize: 99999,
        pageNo: 1,
        storeCode: val,
      };
      const { result } = await this.$store.dispatch(
        "queryStoreShopInfoList",
        params
      );
      this.shopList = result.records;
    },
    async queryShopDetailsList(val) {
      let params = {
        pageSize: 99999,
        pageNo: 1,
        storeCodeList: val,
      };
      const { result } = await this.$store.dispatch(
        "queryStoreShopInfoListNew",
        params
      );
      this.shopDetailsList = result.records;
    },
    async queryBrandList() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
      };
      const { result } = await this.$store.dispatch(
        "queryHemiaoBrandList",
        params
      );
      this.allBrandList = result.records;
    },
    async queryStoreList() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      this.storeList = result;
      this.allMerchant = result;
    },
    async edit(row) {
      this.ruleForm = {
        storeCode: "",
        shopIds: [],
        brandIds: [],
      };
      this.row = row;
      this.title = "群编辑";
      this.type = "edit";
      this.dialogVisible = true;
      const { result } = await this.$store.dispatch(
        "queryWxGroupInfoDetailsNew",
        row
      );
      if (result.storeCodeList && result.storeCodeList.length > 0) {
        this.ruleForm.storeCodeList = result.storeCodeList;
        let queryStoreCode = this.ruleForm.storeCodeList.toString();
        console.log("queryStoreCode:", queryStoreCode);
        this.allMerchant.forEach((v) => {
          this.ruleForm.storeCodeList.forEach((o) => {
            if (v.storeCode === o) {
              v.isShow = true;
            }
          });
        });
        this.storeEditList = this.allMerchant.filter((v) => v.isShow > -1);
        this.queryShopDetailsList(result.storeCodeList);
        setTimeout(() => {
          this.ruleForm.shopIds = result.wxShopRelList.map((v) => v.shopId);
        }, 0);
      }
      if (result.wxBrandRelList.length) {
        this.ruleForm.brandIds = result.wxBrandRelList.map((v) => v.brandId);
        this.wxBrandRelList = result.wxBrandRelList;
      }
    },
    async editShopBrand(row) {
      this.ruleForm = {
        storeCode: "",
        shopIds: [],
        brandIds: [],
      };      
      this.row = row;
      const { result } = await this.$store.dispatch(
        "queryWxGroupInfoDetailsNew",
        row
      );
      this.wxShopRelList = result.wxShopRelList;      
      if (result.wxShopRelList && result.wxShopRelList.length > 0) {
        setTimeout(() => {
          this.ruleForm.shopIds = result.wxShopRelList.map((v) => v.shopId);
        }, 0);
      }
      this.wxBrandRelList = result.wxBrandRelList;
      if (result.wxBrandRelList.length) {
        this.ruleForm.brandIds = result.wxBrandRelList.map((v) => v.brandId);
        this.wxBrandRelList.forEach(v=>{
          this.allBrandList.forEach(o=>{
            if(v.brandId === o.hemiaoBrandId){
              v.brandName = o.brandName;
            }
          })
        })
      }
      this.resetForm = false;
      this.$nextTick(() => {
        this.resetForm = true;
      });
      this.dialogVisibleShop = true;
    },
    msglog() {
      this.title = "消息日志";
      this.type = "msglog";
      this.dialogVisible = true;
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryGroupList", params);
      this.list = result.records;
      this.total = result.total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async add() {
      const { code } = await this.$store.dispatch("");
      if (code === "0") {
        this.$message({
          message: "同步成功",
          type: "success",
        });
        this.queryList();
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    importErr() {
      this.importErrDialog = false;
      this.queryList();
    },
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "群名称",
          "商户名称",
          "门店名称(可输入全部,或者多个逗号隔开)",
          "品牌名称(多个品牌使用逗号隔开)",
        ];
        const data = [];
        exportJsonToExcel(tHeader, data, "导出微信群模板");
      });
    },
    // 导入excel
    async importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let groupInfo = [];
        result.forEach((v) => {
          // if (v[0]) {
          //   goodsSns.push(v[0]);
          // }
          if (v[0] || v[1]) {
            groupInfo.push({
              groupName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              storeName: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              shopName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
              brandName: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
            });
          }
        });
        console.log("导入的群名称:", groupInfo);
        that.$store
          .dispatch("importGroup", groupInfo)
          .then((res) => {
            const { code, result } = res;
            if (code === "0") {
              that.$message({
                message: "导入成功!",
                type: "success",
              });
              that.queryList();
            } else {
              const { code, result, errMsg } = res;
              that.importErrDialog = true;
              that.errInputResult = result;
            }
          })
          .catch((res) => {
            const { code, result, errMsg } = res;
            if (result) {
              that.importErrDialog = true;
              that.errInputResult = result;
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("delGroupInfo", row).then((res) => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success",
            });
            this.queryList();
          }
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.storeBasicList = this.allMerchant.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeBasicList = [];
      }
    },
    remoteMethodEdit(query) {
      if (query !== "") {
        this.storeEditList = this.allMerchant.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeEditList = [];
      }
    },
    changeTab(val) {
      this.resetForm = false;
      this.$nextTick(() => {
        this.resetForm = true;
      });
      console.log(val);
    },
    addShop() {
      this.title = "新增门店";
      this.dialogVisibleAddShop = true;
      this.notRelShopList.records = [];
      this.notRelShopList.total = 0;
      this.shopCurrentPage = 1;
      this.shopPageSize = 10;
      this.queryStoreListAdd();
    },

    searchShop() {
      this.canClick = false;
      if (this.storeCodeList.length) {
        this.shopCurrentPage = 1;
        this.importData = false;
        this.queryShopList();
      } else {
        this.$message({
          message: "请选择商户",
          type: "warning",
        });
      }
    },
    queryStoreListAdd() {
      let params = {
        pageSize: this.storePageSize,
        pageNo: this.storeCurrentPage,
        storeName: this.storeName,
        queryRewardFlag: "exclude",
        queryRewardNumStat: "exclude",
        queryShopStat: "include",
        queryTemplateStat: "exclude",
        queryRiskeStat: "exclude",
      };
      this.$store.dispatch("queryStoreBasicList", params);
    },
    storeSearch() {
      this.storeCurrentPage = 1;
      this.queryStoreListAdd();
    },
    storePaging(page) {
      this.storeCurrentPage = page;
      this.queryStoreListAdd();
    },
    storeHandleSizeChange(size) {
      this.storeCurrentPage = 1;
      this.storePageSize = size;
      this.queryStoreListAdd();
    },
    queryShopList() {
      let params = {
        pageSize: this.shopPageSize,
        pageNo: this.shopCurrentPage,
        shopName: this.shopName,
        storeCodeList: this.storeCodeList,
        supplierCode: this.$route.query.storeCode,
      };
      this.$store.dispatch("queryNotRelShopList", params);
    },
    shopSearch() {
      this.shopCurrentPage = 1;
      this.queryShopList();
    },
    shopPaging(page) {
      this.shopCurrentPage = page;
      this.queryShopList();
    },
    shopHandleSizeChange(size) {
      this.shopCurrentPage = 1;
      this.shopPageSize = size;
      this.queryShopList();
    },
    handleSelectionChange(row) {
      this.storeCodeList = row.map((v) => v.storeCode);
    },
    handleSelectionChangeBrand(row) {
      this.brandListSelect = row.map((v) => v.hemiaoBrandId);
    },
    handleSelectionChangeWxBrand(row) {
      this.wxbrandListSelect = row.map((v) => v.brandId);
    },
    handleSelectionChangeWxShop(row) {
      this.wxShopListSelect = row.map((v) => v.shopId);
    },
    //左边表格表格选中
    tableSelect(row, column, event) {
      this.$refs.roleTable.toggleRowSelection(row);
    },
    tableSelectBrand(row, column, event) {
      this.$refs.brandTable.toggleRowSelection(row);
    },
    getShopChecked(selection) {
      this.checkedShopRow = selection;
      console.log("selection::::", this.checkedShopRow);
    },
    rightTableSelect(row, column, event) {
      if (column.label != "对应组织机构") {
        this.$refs.rightData.toggleRowSelection(row);
      }
    },
    batchDepart(val) {
      if (val.length > 0) {
        if (this.checkedShopRow <= 0) {
          this.$message({
            message: "请选择",
            type: "warning",
          });
        } else {
          this.checkedShopRow.forEach((v, i) => {
            v.departIds = [val[val.length - 1].value];
            setTimeout(() => {
              this.$refs["cascader" + v.shopId].presentText =
                val[val.length - 1].label;
            }, 0);
          });
          this.checkedShopRow = [...this.checkedShopRow];
        }
      } else {
        this.checkedShopRow.forEach((v, i) => {
          this.$refs["cascader" + v.shopId].presentText = "";
          v.departIds = [];
        });
      }
    },
    qx() {
      this.dialogVisibleAddShop = false;
      this.rest();
    },
    rest() {
      setTimeout(() => {
        this.departIds = "";
        this.storeCode = "";
        this.storeName = "";
        this.shopName = "";
        this.storeBasucList.records = [];
        this.storeBasucList.total = 0;
        this.notRelShopList.records = [];
        this.notRelShopList.total = 0;
      }, 0);
    },
    async confirm() {
      console.log("this.checkedShopRow:", this.checkedShopRow);
      if (this.checkedShopRow <= 0) {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      } else {
        console.log("新增门店");
        this.checkedShopRow.map((item) => {
          this.ruleForm.shopIds.push(item.shopId);
        });
        this.ruleForm.shopIds = unique(this.ruleForm.shopIds);
        this.dialogVisibleAddShop = false;
        console.log("this.ruleForm.shopIds:",this.ruleForm.shopIds);        
        this.refresh();
      }
    },
    addBrand() {
      this.queryAddBrandList();
      this.title = "新增品牌";
      this.dialogVisibleAddBrand = true;
      console.log("添加品牌");
    },
    async queryAddBrandList() {
      let params = {
        pageSize: this.brandPageSize,
        pageNo: this.brandCurrentPage,
        brandName : this.brandName
      };
      const { result } = await this.$store.dispatch(
        "queryHemiaoBrandList",
        params
      );
      if(result){
        this.brandList = result.records;
        this.brandTotal = result.total;
      }
    },
    brandSearch(){
      this.queryAddBrandList();
    },
    brandPaging(page) {
      this.brandCurrentPage = page;
      this.queryAddBrandList();
    },
    brandHandleSizeChange(size) {
      this.brandCurrentPage = 1;
      this.brandPageSize = size;
      this.queryAddBrandList();
    },
    brandConfirm(){
      console.log("this.brandListSelect:", this.brandListSelect);
      if (this.brandListSelect.length <= 0) {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      } else {
        console.log("新增品牌");
        this.ruleForm.brandIds.push(...this.brandListSelect);
        this.ruleForm.brandIds = unique(this.ruleForm.brandIds);
        this.dialogVisibleAddBrand = false;
        console.log("this.ruleForm.brandIds:",this.ruleForm.brandIds);
        this.refresh();
      }
    },
    removeBrand(row){
      console.log("删除品牌:",row);
      this.ruleForm.brandIds.forEach((v,i)=>{
        if(v === row.brandId){
          this.ruleForm.brandIds.splice(i, 1);
        }
      })
      this.refresh();
      console.log("this.ruleForm.brandIds:",this.ruleForm.brandIds);
    },
    batchDeleteBrand(){
      console.log("批量删除品牌")
      if (this.wxbrandListSelect.length <= 0) {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      } else {
        console.log("this.wxbrandListSelect",this.wxbrandListSelect);
        this.ruleForm.brandIds = getSubtract2(this.ruleForm.brandIds, this.wxbrandListSelect);
        console.log("this.ruleForm.brandIds:",this.ruleForm.brandIds);
        this.refresh();
      }
    },
    async removeShop(row){
      this.ruleForm.shopIds.forEach((v,i)=>{
        if(v === row.shopId){
          this.ruleForm.shopIds.splice(i, 1);
        }
      })
      console.log("this.ruleForm.shopIds:",this.ruleForm.shopIds);
      this.refresh();
    },
    async batchDeleteShop(){
      console.log("批量删除门店")
      if (this.wxShopListSelect.length <= 0) {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      } else {
        console.log("this.wxShopListSelect",this.wxShopListSelect);
        this.ruleForm.shopIds = getSubtract2(this.ruleForm.shopIds, this.wxShopListSelect);
        console.log("this.ruleForm.shopIds:",this.ruleForm.shopIds);
        this.refresh();
      }
    },
    async refresh(){
      await this.editGroup();
      await this.editShopBrand(this.row);
    },    
  },
};
</script>
<style lang="scss" scoped>
.seach_checked {
  width: 160px;
  height: 100%;
  padding-top: 20%;
  padding-left: 15px;
  margin-right: 25px;
  box-sizing: border-box;
}
.fr {
  float: right;
}
</style>
